import {useEffect, useRef, useState} from 'react';
import './_mini-map.scss';
import VButton from "../../v-button/v-button";
import puzzles from "../../../utils/puzzles";
import VStore from "../../../store";


export default function MiniMap() {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const [isActivated, setIsActivated] = useState(false);

    const [currentPlot, setCurrentPlot] = useState(1);

    const iframeMap = useRef<HTMLIFrameElement>(null);

    const {setIsLoading} = VStore();

    function _onMouseEnter() {
        setIsActivated(true);
    }

    function _onMouseLeave() {
        setIsActivated(false);
    }

    function _onPrevious() {
        if (iframeMap.current)
            iframeMap.current.contentWindow?.postMessage({target: 'map', type: 'previous'}, '*');
    }

    function _onNext() {
        if (iframeMap.current)
            iframeMap.current.contentWindow?.postMessage({target: 'map', type: 'next'}, '*');
    }

    useEffect(() => {
        window.addEventListener('message', (event) => {
            const {type, target, data} = event.data;
            if (target !== 'mini-map') return;
            if (type === 'update' && currentPlot !== parseInt(data)) {
                setCurrentPlot(data);
                setIsLoading(true);
                puzzles.procedures?.changePlot((parseInt(data) % 2).toString());
            }
        })
    }, []);

    return <div className={"mini-map" + (isCollapsed ? ' collapsed' : (isActivated ? ' active' : ''))}
                onMouseLeave={_onMouseLeave}
    >
        <div className='w-100 d-flex'>
            <div className='mini-map__content'>
                <div className='mini-map__content__map'
                     onMouseEnter={_onMouseEnter}
                >
                    <iframe src="./map" title='Plot Map' ref={iframeMap}></iframe>
                </div>
                <div className='mini-map__content__navigator'>
                    <VButton content={<img src='./assets/images/left-arrow.svg' alt='Previous'/>}
                             width='1.5em'
                             height='1.5em'
                             tooltip='Previous plot'
                             onClick={_onPrevious}
                    />
                    <span>Plot: <span style={{marginLeft: '0.25em'}}>{currentPlot}</span></span>
                    <VButton content={<img src='./assets/images/right-arrow.svg' alt='Next'/>}
                             width='1.5em'
                             height='1.5em'
                             tooltip='Next plot'
                             onClick={_onNext}
                    />
                </div>
            </div>
            <VButton className='mini-map__collapse-btn'
                     onClick={() => setIsCollapsed(!isCollapsed)}
                     content={<img src="./assets/images/double-arrow.svg" alt="Collapse"/>}
                     tooltip={isCollapsed ? 'Expand plat map' : 'Minimize plat map'}
            />
        </div>


    </div>;
}
